import { Component, EventEmitter, Input, Output } from '@angular/core'
import { InformacoesCoordenadorModel } from '@shared/models/backend'

@Component({
  selector: 'app-infos-coordenador',
  templateUrl: './infos-coordenador.component.html',
})
export class InfosCoordenadorComponent {
  @Input()
  infosCoordenador: InformacoesCoordenadorModel
  @Input()
  hasButton: boolean

  @Output()
  alterarClick: EventEmitter<void> = new EventEmitter()

  onAlterarClicked(): void {
    this.alterarClick.emit()
  }
}
